var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-sub-title-warp",
      on: {
        click: function ($event) {
          return _vm.onClickCardTitleMore()
        },
      },
    },
    [
      _c(
        "van-row",
        {
          staticStyle: { "align-items": "center" },
          attrs: { type: "flex", justify: "space-between" },
        },
        [
          _c("van-col", { staticClass: "card-sub-title-name" }, [
            _c("span", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _vm.reviewTime
              ? _c("span", { staticClass: "review-time" }, [
                  _vm._v(_vm._s(_vm.time)),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isSubMore
            ? _c("van-col", { staticClass: "card-sub-title-more" }, [
                _vm._v("更多"),
                _c("i", { staticClass: "iconfont ic-arrow-right-o" }),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }